import React from 'react'
import { motion } from 'motion/react'

export default function DialogueSessions() {
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  }
  
  const cardVariants = {
    hidden: {
      opacity: 0,
      x: 40,
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  }
  
  const sessions = [
    {
      number: '1',
      title: 'منهج القدرات: قيادة المؤسسات لمستقبل التنافسية',
      speakers: [
        'أ. صفاء بنت عبدالله الراشد',
        'أ.د. علي بن أحمد أبو شرحة',
        'أ.د. خالد العصفور',
        'د. هدى عبدالله بن سعيدان',
      ],
      moderator: 'د. أحمد المعيدي',
      date: 'الاثنين 19 يناير 2026',
      time: '2:00 – 2:30 مساءً',
    },
    {
      number: '2',
      title: 'القيادة والثقافة المؤسسية',
      speakers: [
        'أ. إيمان الزعبي',
        'أ. عبدالله الشمراني',
        'أ. مروان البازعي',
      ],
      moderator: 'د. بثينة بنت محمد الثويني',
      date: 'الثلاثاء 20 يناير 2026',
      time: '9:30 – 10:15 صباحًا',
    },
    {
      number: '3',
      title: 'القيادة في عصر الذكاء الاصطناعي',
      speakers: [
        'د. تغريد السراج',
        'أ. إسراء محمد الشريف',
        'أ. شذا مكي',
      ],
      moderator: 'أ. أريج سعيد سالم باهمام',
      date: 'الثلاثاء 20 يناير 2026',
      time: '10:45 – 11:30 صباحًا',
    },
    {
      number: '4',
      title: 'من التدريب إلى الأثر: دور القيادات في بناء الأثر',
      speakers: [
        'أ. عبدالمجيد بن محمد القصيبي',
        'د. خلود العبدالكريم',
      ],
      moderator: 'د. طلال عبدالرحمن الشثري',
      date: 'الأربعاء 21 يناير 2026',
      time: '9:30 – 10:15 صباحًا',
    },
    {
      number: '5',
      title: 'الإرشاد للمستقبل: دور المجتمع في تمكين القدرات وصناعة قادة التغيير',
      speakers: [
        'د. صالح الحارثي',
        'أ. معيض بن ناصر البيشي',
      ],
      moderator: 'د. أنس الشعالن',
      date: 'الأربعاء 21 يناير 2026',
      time: '10:45 – 11:30 صباحًا',
    },
    {
      number: '6',
      title: 'التدريب رافعة التحول المجتمعي لتسريع تحقيق أهداف التنمية المستدامة',
      speakers: [
        'أ. سارة عجي الصحبي',
        'د. نادية عبدالله الشهراني',
        'أ. غادة حمد المطلق',
        'أ. نزار العوفي',
      ],
      moderator: 'د. عبير العتيبي',
      date: 'الأربعاء 21 يناير 2026',
      time: '1:00 – 1:45 مساءً',
    },
  ]
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
      className="bg-[#f7f8fa] py-24 px-4"
    >
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-sky-700">
            الجلسات الحوارية
          </h2>
        </motion.div>

        {/* Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid gap-8 md:grid-cols-2"
        >
          {sessions.map((session) => (
            <SessionCard key={session.number} {...session} />
          ))}
        </motion.div>

      </div>
    </motion.section>


  )
}
function SessionCard({ number, title, speakers, moderator, date, time }) {
  const cardVariants = {
    hidden: {
      opacity: 0,
      x: 40,
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  }
  return (
    <motion.div
      variants={cardVariants}
      whileHover={{ y: -6 }}
      dir="rtl"
      className="
        relative rounded-3xl bg-white
        border border-slate-200
        shadow-sm hover:shadow-lg
        transition p-8 space-y-6
      "
    >
      {/* Header */}
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold text-sky-700">
          جلسة حوارية
        </span>
        <span className="flex h-10 w-10 items-center justify-center
          rounded-full bg-sky-100 text-sky-800 font-extrabold">
          {number}
        </span>
      </div>

      {/* Title */}
      <h3 className="text-xl font-extrabold text-slate-900 leading-snug">
        {title}
      </h3>

      {/* Speakers */}
      {/* <div>
        <p className="mb-2 text-sm font-semibold text-slate-600">
          المحاورين
        </p>
        <ul className="space-y-1 text-slate-800">
          {speakers.map((s, i) => (
            <li key={i}>• {s}</li>
          ))}
        </ul>
      </div> */}

      {/* Moderator */}
      {/* <div className="rounded-xl bg-sky-50 p-4">
        <p className="text-sm font-semibold text-sky-700">
          مدير الجلسة
        </p>
        <p className="font-bold text-slate-900">
          {moderator}
        </p>
      </div> */}

      {/* Meta */}
      <div className="grid sm:grid-cols-3 gap-4 text-sm text-slate-600">
        <div>📅 {date}</div>
        <div>⏰ {time}</div>
        <div>📍 مسرح الملتقى – بهو الجامعة</div>
      </div>
    </motion.div>
  )
}

